import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { useTheme } from 'Components/ComponentLibrary/Styles';

const FolderOpen = props => {
  const theme = useTheme();

  return (
    <SvgIcon viewBox="0 0 77.507 55.362" {...props}>
      <path id="Icon_ionic-md-folder-open" data-name="Icon ionic-md-folder-open" d="M72.375,15.054H41l-7.382-8.3H9.632A7.4,7.4,0,0,0,2.25,14.132v40.6a7.4,7.4,0,0,0,7.382,7.382H72.375a7.4,7.4,0,0,0,7.382-7.382V22.436A7.4,7.4,0,0,0,72.375,15.054ZM74.221,54.73a1.87,1.87,0,0,1-1.845,1.845H9.632A1.87,1.87,0,0,1,7.786,54.73V20.591H72.375a1.87,1.87,0,0,1,1.845,1.845Z" transform="translate(-2.25 -6.75)" fill={theme.palette.primary.main} />
    </SvgIcon>
  );
};

export default FolderOpen;
